<template>
  <div class="card-users">
    <h3 v-if="title" class="card-users__title">{{ title }}</h3>
    <div class="card-users__users">
      <CardUsersEditor v-if="showEditor" @add-user="addUser" @remove-user="removeUser" />
      <!-- first visible group -->
      <template v-if="!usersVisible">
        <UserAvatar
          v-for="user in ellipsis ? computedUsers.firstVisible : users"
          :key="user.id"
          :user="user"
        />
      </template>
      <!-- hidden group -->
      <div
        v-if="ellipsis && computedUsers.hidedUsers.length"
        class="card-users__hided"
        @mouseenter="showUsers"
        @mouseleave="hideUsers"
      >
        <AppIcon v-if="!hideIcon" icon="far fa-ellipsis-h" />
        <!-- group -->
        <TransitionGroupEllipsis
          class="card-users__hided-listing"
          tag="div"
          :time="transitionTime"
          direction="left"
        >
          <template v-if="usersVisible">
            <UserAvatar v-for="user in computedUsers.hidedUsers" :key="user.id" :user="user" />
          </template>
        </TransitionGroupEllipsis>
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
// Componenets
import AppIcon from 'Ui/AppIcon'
import UserAvatar from 'Components/UserAvatar'
import CardUsersEditor from './components/CardUsersEditor'
import TransitionGroupEllipsis from 'Components/TransitionGroupEllipsis'

export default {
  name: 'CardUsers',

  components: {
    AppIcon,
    UserAvatar,
    CardUsersEditor,
    TransitionGroupEllipsis,
  },

  props: {
    users: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      required: false,
    },

    showEditor: {
      type: Boolean,
      default: false,
    },

    ellipsis: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hideIcon: false,
      usersVisible: false,
      transitionTime: 600,
    }
  },

  methods: {
    showUsers() {
      this.hideIcon = true
      this.usersVisible = true
    },

    hideUsers() {
      this.hideIcon = false
      this.usersVisible = false
    },

    getUserData(user, action) {
      return {
        id: this.$route.params.card_id,
        user,
        action,
        newValues: {
          [action === 'add' ? 'add_user' : 'remove_user']: user.id,
        },
      }
    },

    handleUserToggleRequest(user) {
      const isInCard = this.users.some((u) => u.id == user.id)

      !isInCard && this.addUser(user)
      isInCard && this.removeUser(user)
    },

    addUser(user) {
      const userData = this.getUserData(user, 'add')
      this.updateCardUsers(userData)
    },

    removeUser(user) {
      const userData = this.getUserData(user, 'remove')
      this.updateCardUsers(userData)
    },

    updateCardUsers(userData) {
      this.$store.dispatch('cards/updateCard', userData)
    },
  },

  computed: {
    computedUsers() {
      return {
        firstVisible: this.users.slice(0, 3),
        hidedUsers: this.users.slice(3),
      }
    },
  },

  created() {
    // const enventDeclared = !!EventBus._events['add-card-user']
    // if (enventDeclared) return
    this.showEditor && EventBus.$on('add-card-user', this.handleUserToggleRequest)
  },

  destroyed() {
    EventBus.$off('add-card-user', this.handleUserToggleRequest)
  },
}
</script>

<style scoped>
.card-users {
  display: grid;
  gap: 5px;
}

.card-users__users {
  display: flex;
  align-items: center;
  gap: 5px;
}

.card-users__title {
  font-size: 12px;
  letter-spacing: 0.3px;
}

.card-users .diy-popper {
  order: 1;
}

.card-users__hided {
  position: relative;
}

.card-users__hided,
.card-users__hided .app-icon {
  width: 34px;
  height: 34px;
}

.card-users__hided .app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: 50px;
  color: var(--c-secondary);
  background-color: var(--c-secondary-400);
  pointer-events: none;
  z-index: 1;
}

.card-users__hided-listing {
  display: grid;
  position: absolute;
  grid-gap: 5px;
  border-radius: 20px;
  z-index: 10;
}

.card-users__hided-listing .user {
  margin: 0;
}
</style>
